import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const makeInitialState = () => ({
  data: [],
  selected: null,
  status: 'Unfetched',
  errMessage: null,
});

export default {
  namespaced: true,
  state: makeInitialState(),
  actions,
  mutations,
  getters,
  hagridOn: {
    logout: 'clear',
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/projects/index.js